const L = `<svg width="14" height="16" viewBox="0 0 14 16" xmlns="http://www.w3.org/2000/svg">\r
<path d="M1.4 15.2414L0 13.7931L5.6 7.99998L0 2.20688L1.4 0.758606L7 6.55171L12.6 0.758606L14 2.20688L8.4 7.99998L14 13.7931L12.6 15.2414L7 9.44826L1.4 15.2414Z"/>\r
</svg>\r
`;
export {
  L as default
};
